import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthRequest } from '@shared/models/auth.model';
import { Observable, catchError, map, of } from 'rxjs';

import { BaseService } from './base.service';
import { environment as env } from '../../../environments/environment';

@Injectable()
export class AuthService extends BaseService {
  constructor(private readonly http: HttpClient) {
    super();
    this.envService = env.services.auth;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  public logIn(payload: AuthRequest): Observable<any> {
    const body = new HttpParams()
      .set('username', payload.username)
      .set('password', payload.password)
      .set('grant_type', payload.grant_type);

    this.headers = this.headers.set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post<any>(this.getFullUrl(this.env.services.auth.token), body, { headers: this.headers });
    // return of(
    //   {
    //       "access_token": "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZW5hbnRfaW5mbyI6eyJtZXJjaGFudCI6IjAwNzgzNCIsInNpdGVzIjpbIlRIIl0sImdyb3VwcyI6W10sInN0b3JlcyI6WyIqIl19LCJ1c2VyX2luZm8iOnsidXNlcklkIjoiNjVhNWY1NzU3MGIwMzkzZmU4Yzg3ODA1IiwidXNlck5hbWUiOiJjanhzdG9yZW1uZy5jaiIsInVzZXJObyI6IjAwOTM1NCIsInVzZXJDb2RlIjoiMDAwMTgiLCJmaXJzdE5hbWUiOiJDanhzdG9yZW1uZyIsImxhc3ROYW1lIjoiQ2p4c3RvcmVtbmciLCJsb2NhbEZpcnN0TmFtZSI6ImNqeHN0b3JlbW5nIiwibG9jYWxMYXN0TmFtZSI6ImNqeHN0b3JlbW5nIiwiZW1haWwiOiJjanhzdG9yZW1uZ0BtYWlsaW5hdG9yLmNvbSIsIm1vYmlsZU5vIjoiMDgwMDAwMDAwMSIsInJvbGVzIjpbIlNUT1JFX01BTkFHRVIiXSwiZm9yY2VDaGFuZ2VQYXNzd29yZCI6dHJ1ZSwiZm9yY2VDaGFuZ2VQaW5Db2RlIjp0cnVlLCJwcm9maWxlSW1hZ2VOYW1lIjpudWxsfSwidXNlcl9uYW1lIjoiY2p4c3RvcmVtbmcuY2oiLCJzY29wZSI6WyJpZGVudGl0eSIsIm1lcmNoYW50Iiwic3RvcmUiLCJvcmRlciJdLCJleHAiOjE3MDUzOTE0NjUsIm1lcmNoYW50X2luZm8iOnsibWVyY2hhbnRObyI6IjAwNzgzNCIsIm1lcmNoYW50TmFtZSI6IuC4muC4o-C4tOC4qeC4seC4lyDguIvguLXguYDguIgg4Lih4Liy4Lij4LmM4LiXIOC4iOC4s-C4geC4seC4lCJ9LCJhdXRob3JpdGllcyI6WyJtb25leV9tIiwicmVwb3J0X3YiLCJzZl9wYXJ0bmVyX3d0YyIsInN0b2NrX3YiLCJwb3NfdGFza192IiwidGhfcm9fdiIsInRoX2NyX3YiLCJ0aF9zbl92IiwidGhfdGFza192Iiwib3JkZXJfZ3IiLCJ0aF9yb19tIiwicG9zX3BvZ192IiwibGluZW9hX3AiLCJzYWxlX20iLCJ0aF9zYWxlX20iLCJhc3NvcnRtZW50X3YiLCJ0aF90YXNrX20iLCJ0aF9oejhfbSIsIm1vbmV5X3YiLCJ0aF9jcl9tIiwicG9zX3Rhc2tfbSIsInRoX2NzX20iLCJzYWxlX3ZvdWNoZXIiXSwianRpIjoiMGQ3ZmNjZjQtNWQwYi00MzEyLTk2MTAtMzIxMWUyZTg3MTliIiwiY2xpZW50X2lkIjoiUE9TX0FQUEwifQ.l8_-G71iEwMlQjiOjiRXSI5LtrUj4qdb5u22R3UyAkZGxEXqELmPFbC2m5aSdPFdJYeK9EwLe6OroThxQbEa2DDxtmY7mF8eiwO0iSjso_HDIbMECb3qVzLPj2amV2hXgkfZzJpB57tardRnGzAiAO6Eh1nTVZsvEx1F0YkIHMZiXQcOLaIjzujfOf3a3PSPICpokhDNDHn5uD-Gn2NuPNydiY5GKNZNTbv3BC9L00JWHYhskTZKHCpERy9_RoeLs3h1mvxFU8tBuhQVYog7h0EORUoUL307Ar58uTYRnhyYKEmChVBv3b3v21OPxVH7z6CjB5MAzC2YIRbW0LWHcg",
    //       "token_type": "bearer",
    //       "refresh_token": "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZW5hbnRfaW5mbyI6eyJtZXJjaGFudCI6IjAwNzgzNCIsInNpdGVzIjpbIlRIIl0sImdyb3VwcyI6W10sInN0b3JlcyI6WyIqIl19LCJ1c2VyX2luZm8iOnsidXNlcklkIjoiNjVhNWY1NzU3MGIwMzkzZmU4Yzg3ODA1IiwidXNlck5hbWUiOiJjanhzdG9yZW1uZy5jaiIsInVzZXJObyI6IjAwOTM1NCIsInVzZXJDb2RlIjoiMDAwMTgiLCJmaXJzdE5hbWUiOiJDanhzdG9yZW1uZyIsImxhc3ROYW1lIjoiQ2p4c3RvcmVtbmciLCJsb2NhbEZpcnN0TmFtZSI6ImNqeHN0b3JlbW5nIiwibG9jYWxMYXN0TmFtZSI6ImNqeHN0b3JlbW5nIiwiZW1haWwiOiJjanhzdG9yZW1uZ0BtYWlsaW5hdG9yLmNvbSIsIm1vYmlsZU5vIjoiMDgwMDAwMDAwMSIsInJvbGVzIjpbIlNUT1JFX01BTkFHRVIiXSwiZm9yY2VDaGFuZ2VQYXNzd29yZCI6dHJ1ZSwiZm9yY2VDaGFuZ2VQaW5Db2RlIjp0cnVlLCJwcm9maWxlSW1hZ2VOYW1lIjpudWxsfSwidXNlcl9uYW1lIjoiY2p4c3RvcmVtbmcuY2oiLCJzY29wZSI6WyJpZGVudGl0eSIsIm1lcmNoYW50Iiwic3RvcmUiLCJvcmRlciJdLCJhdGkiOiIwZDdmY2NmNC01ZDBiLTQzMTItOTYxMC0zMjExZTJlODcxOWIiLCJleHAiOjE3MDU0NzY2NjUsIm1lcmNoYW50X2luZm8iOnsibWVyY2hhbnRObyI6IjAwNzgzNCIsIm1lcmNoYW50TmFtZSI6IuC4muC4o-C4tOC4qeC4seC4lyDguIvguLXguYDguIgg4Lih4Liy4Lij4LmM4LiXIOC4iOC4s-C4geC4seC4lCJ9LCJhdXRob3JpdGllcyI6WyJtb25leV9tIiwicmVwb3J0X3YiLCJzZl9wYXJ0bmVyX3d0YyIsInN0b2NrX3YiLCJwb3NfdGFza192IiwidGhfcm9fdiIsInRoX2NyX3YiLCJ0aF9zbl92IiwidGhfdGFza192Iiwib3JkZXJfZ3IiLCJ0aF9yb19tIiwicG9zX3BvZ192IiwibGluZW9hX3AiLCJzYWxlX20iLCJ0aF9zYWxlX20iLCJhc3NvcnRtZW50X3YiLCJ0aF90YXNrX20iLCJ0aF9oejhfbSIsIm1vbmV5X3YiLCJ0aF9jcl9tIiwicG9zX3Rhc2tfbSIsInRoX2NzX20iLCJzYWxlX3ZvdWNoZXIiXSwianRpIjoiNGJlODUzODMtMTZhOC00ODFhLTlhZjQtMDhiN2Q2NzE1Y2RlIiwiY2xpZW50X2lkIjoiUE9TX0FQUEwifQ.ETveUzCozqw5EicHD6uVmt_WRbLzg6N_tdrX7iQZctVjVxtHtQIJeGkBoUfUGEJLVyroxcanumzY1CC35DgzlDfMltGMKImb1ooQMpO3U-N3WzxBo1rah5GbkTZmOIuy9Cv7vsXIQyxrwonEdmM2MnBiqCD5ubLlixihJFbFEvld87zTvIWu9Qd7Iyo4m0dpdTrs2IN6cL5ROp1UUZegz2w3TAuPQg8eG2VkRZRbHoaiRQ2G2RWBn8MvCodBcoZnBZzOAlst2mKHzK5lm5TJHTGSUXLspc4zhnge725_wejQY1GCxobI0ST-FJX6cyw14eaN646wTQNBJYT12LFupw",
    //       "expires_in": 1199,
    //       "scope": "identity merchant store order",
    //       "user_info": {
    //           "userId": "65a5f57570b0393fe8c87805",
    //           "userName": "cjxstoremng.cj",
    //           "userNo": "009354",
    //           "userCode": "00018",
    //           "firstName": "Cjxstoremng",
    //           "lastName": "Cjxstoremng",
    //           "localFirstName": "cjxstoremng",
    //           "localLastName": "cjxstoremng",
    //           "email": "cjxstoremng@mailinator.com",
    //           "mobileNo": "0800000001",
    //           "roles": [
    //               "STORE_MANAGER"
    //           ],
    //           "forceChangePassword": true,
    //           "forceChangePinCode": true,
    //           "profileImageName": null
    //       },
    //       "merchant_info": {
    //           "merchantNo": "007834",
    //           "merchantName": "บริษัท ซีเจ มาร์ท จำกัด"
    //       },
    //       "tenant_info": {
    //           "merchant": "007834",
    //           "sites": [
    //               "TH"
    //           ],
    //           "groups": [],
    //           "stores": [
    //               "*"
    //           ]
    //       },
    //       "jti": "0d7fccf4-5d0b-4312-9610-3211e2e8719b"
    //   })
  }

  public refreshToken(refreshToken: string): Observable<any> {
    const body = new HttpParams().set('refresh_token', refreshToken).set('grant_type', 'refresh_token');

    this.headers = this.headers.set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post<any>(this.getFullUrl(this.env.services.auth.token), body, { headers: this.headers });
  }

  public bypassAuthenToken<T>(): Observable<T> {
    const body = new HttpParams().set('grant_type', 'client_credentials');
    return this.http.post<T>(this.getFullUrl(this.env.services.auth.token), body, { headers: this.headers });
  }

  public userInfo(accessToken): Observable<any> {
    const body = new HttpParams().set('grant_type', 'client_credentials');

    this.headers = this.headers
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .set('Authorization', `Bearer ${accessToken}`);

    return this.http.post<any>(this.getFullUrl(this.env.services.auth.userInfo), body, { headers: this.headers });
  }

  // public requiredAction(accessToken): Observable<any> {
  //   const param = {
  //     username: 'paruj.le@tdshop.io'
  //   };
  //   const params = this.getParams(param);

  //   this.headers = this.headers
  //     .set('Content-Type', 'application/x-www-form-urlencoded')
  //     .set('Authorization', `Bearer ${accessToken}`);

  //   return this.http.get<any>('https://tdsc-api-dev.tdshop.io/sys/admin/iam/api/users/required-actions', {
  //     headers: this.headers,
  //     observe: 'body',
  //     params
  //   });
  // }

  public getWebVersion() {
    return this.http.get('/assets/VERSION', { responseType: 'text' }).pipe(
      map((val) => val.trim()),
      catchError(() => of(null))
    );
  }
}
